import api from "./api";

export const adminService = {
  async getUsers(params = {}) {
    const queryParams = new URLSearchParams(
      Object.entries(params || {}).filter(
        ([, value]) => value !== undefined && value !== null && value !== "",
      ),
    ).toString();
    const response = await api.get(
      `/admin/users${queryParams ? `?${queryParams}` : ""}`,
    );
    return response.data;
  },

  async getUserById(id) {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  async updateUser(id, userData) {
    const response = await api.put(`/admin/users/${id}`, userData);
    return response.data;
  },

  async deleteUser(id) {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  async getAllTransactions(params = {}) {
    const searchParams = new URLSearchParams(
      Object.entries(params || {}).filter(
        ([, value]) => value !== undefined && value !== null && value !== "",
      ),
    ).toString();

    const response = await api.get(
      `/admin/transactions${searchParams ? `?${searchParams}` : ""}`,
    );
    return response.data;
  },

  async getDashboardStats() {
    const response = await api.get("/admin/stats");
    return response.data;
  },

  async getVirtualNumberPurchases() {
    const response = await api.get("/admin/virtual-number-purchases");
    return response.data;
  },

  // manual payment management
  async createManualAccount(accountData) {
    const response = await api.post("/admin/manual/accounts", accountData);
    return response.data;
  },

  async updateManualAccount(id, accountData) {
    const response = await api.put(`/admin/manual/accounts/${id}`, accountData);
    return response.data;
  },

  async deleteManualAccount(id) {
    const response = await api.delete(`/admin/manual/accounts/${id}`);
    return response.data;
  },

  async getManualDeposits(params = {}) {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(
      `/admin/manual/deposits${query ? `?${query}` : ""}`,
    );
    return response.data;
  },

  async updateManualDepositStatus(id, status) {
    const response = await api.put(`/admin/manual/deposits/${id}/status`, {
      status,
    });
    return response.data;
  },

  async syncVirtualNumberPrices(providerId = "herosms") {
    const response = await api.post("/virtual-numbers/admin/sync", {
      providerId,
    });
    return response.data;
  },

  async getVirtualNumberPrices(params = {}) {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(
      `/virtual-numbers/admin/prices${query ? `?${query}` : ""}`,
    );
    return response.data;
  },

  async updateVirtualNumberPrice(id, data) {
    const response = await api.put(`/virtual-numbers/admin/prices/${id}`, data);
    return response.data;
  },

  async bulkUpdateVirtualNumberPrices(payload) {
    const response = await api.post(
      "/virtual-numbers/admin/bulk-update",
      payload,
    );
    return response.data;
  },

  async getVirtualNumberCountries(params = {}) {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(
      `/virtual-numbers/admin/countries${query ? `?${query}` : ""}`,
    );
    return response.data;
  },

  async getVirtualNumberProviders() {
    const response = await api.get("/virtual-numbers/admin/providers");
    return response.data;
  },

  async toggleVirtualNumberProvider(providerId, isEnabled) {
    const response = await api.patch(
      `/virtual-numbers/admin/providers/${providerId}`,
      { isEnabled },
    );
    return response.data;
  },

  async approvePendingTransaction(transactionId) {
    const response = await api.post("/payments/admin/approve/" + transactionId);
    return response.data;
  },
};
